module.exports = __webpack_public_path__ + "media/images/landing-pages/lp-sec-crs-1-b2d06786c00f83827ceb6b2ed5956d3c.png";